/** Conteúdo dos 7 passos do onboarding de contratação (Figma 8418-7100 … 8418-10948). */
export const INFRACTION_ONBOARDING_STEPS = [
	{
		title: "Potencialize sua Gestão de Infrações",
		description:
			"Conecte sua empresa e tenha controle total das suas multas, evitando surgimento das NICs.",
	},
	{
		title: "Acesso Total às Multas",
		description:
			"Visualize e gerencie infrações de toda a sua frota em um único painel.",
	},
	{
		title: "Automatização da FICI",
		description:
			"Elimine o preenchimento manual de formulários com nossa integração inteligente.",
	},
] as const;

export const INFRACTION_ONBOARDING_TOTAL_STEPS =
	INFRACTION_ONBOARDING_STEPS.length;
